<template>
  <v-main class="tw-mt-6">
    <transition
      name="fade-transform"
      mode="out-in"
    >
      <!-- <keep-alive> -->
        <router-view />
      <!-- </keep-alive> -->
    </transition>
  </v-main>
</template>

<script>
export default {
  name: 'TheLayoutContent',
  data: () => ({}),
};
</script>
